import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ListUnpaidParams, UnpaidStatus, Unsolved } from 'src/app/core/unpaid.service';
import { UtilsService } from 'src/app/core/utils.service';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-unpaid-filter-dialog',
  templateUrl: './unpaid-filter-dialog.component.html',
  styleUrls: ['./unpaid-filter-dialog.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
})
export class UnpaidFilterDialogComponent {
  unpaid_filter_from_group: FormGroup = this.form_service.unpaid_filter_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  recovered_status: UnpaidStatus = UnpaidStatus.recovered;
  canceled_status: UnpaidStatus = UnpaidStatus.canceled;
  expired_status: UnpaidStatus = UnpaidStatus.expired;
  pending_status: UnpaidStatus = UnpaidStatus.pending;
  yes: Unsolved = Unsolved.yes;
  no: Unsolved = Unsolved.no;

  constructor(
    private dialog_ref: MatDialogRef<UnpaidFilterDialogComponent>,
    private form_service: FormService,
    private utils_service: UtilsService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const order_id: string | '' = this.unpaid_filter_from_group.get(this.form_service.order_id_label)?.value;
      const step_id: string | '' = this.unpaid_filter_from_group.get(this.form_service.step_id_label)?.value;
      const created_from_text: string = this.unpaid_filter_from_group.get(this.form_service.created_from_label)?.value;
      const created_to_text: string = this.unpaid_filter_from_group.get(this.form_service.created_to_label)?.value;
      const created_from: number = new Date(created_from_text).getTime();
      const created_to: number = new Date(created_to_text).setHours(23, 59, 59, 999);

      const due_date_from_text: string = this.unpaid_filter_from_group.get(
        this.form_service.due_date_from_label,
      )?.value;
      const due_date_to_text: string = this.unpaid_filter_from_group.get(this.form_service.due_date_to_label)?.value;
      const due_date_from: number = new Date(due_date_from_text).getTime();
      const due_date_to: number = new Date(due_date_to_text).setHours(23, 59, 59, 999);
      const status: string = this.unpaid_filter_from_group.get(this.form_service.status_label)?.value;
      const qinetic_id: string | '' = this.unpaid_filter_from_group.get(this.form_service.qinetic_id_label)?.value;
      const unpaid_days: string | '' = this.unpaid_filter_from_group.get(this.form_service.unpaid_days_label)?.value;
      const unsolved: string = this.unpaid_filter_from_group.get(this.form_service.unsolved_label)?.value;
      const store_name: string | '' = this.unpaid_filter_from_group.get(this.form_service.store_name_label)?.value;
      const buyer_name: string | '' = this.unpaid_filter_from_group.get(this.form_service.buyer_name_label)?.value;
      const company_name: string | '' = this.unpaid_filter_from_group.get(this.form_service.company_name_label)?.value;

      const params: ListUnpaidParams = {
        order_id: order_id == '' ? undefined : order_id,
        step_id: step_id == '' ? undefined : step_id,
        created_from: !created_from_text || created_from_text == '' ? undefined : created_from,
        created_to: !created_to_text || created_to_text == '' ? undefined : created_to,
        due_date_from: !due_date_from_text || due_date_from_text == '' ? undefined : due_date_from,
        due_date_to: !due_date_to_text || due_date_to_text == '' ? undefined : due_date_to,
        status: status == '' ? undefined : (status as UnpaidStatus),
        qinetic_id: qinetic_id == '' ? undefined : qinetic_id,
        unpaid_days: unpaid_days == '' ? undefined : unpaid_days,
        unsolved: unsolved == '' ? undefined : unsolved,
        company_name: company_name == '' ? undefined : company_name,
        store_name: store_name == '' ? undefined : store_name,
        buyer_name: buyer_name == '' ? undefined : buyer_name,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.unpaid_filter_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.unpaid_filter_from_group);
  }

  getUnpaidStatusLabel(status: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusLabel(status);
  }
}
